import { CTAProps } from '@/components/CTA';
import React from 'react';
import { CtaGroup } from '../../CtaGroup';
import styles from './TrailingItems.module.scss';

export interface TrailingItemsProps {
  ctas?: CTAProps[];
}

export const TrailingItems: React.FC<TrailingItemsProps> = ({ ctas }) => {
  return (
    <div className={styles.trailing_items}>
      {ctas && <CtaGroup ctas={ctas} className={styles.trailing_items__cta_group} />}
      {/* <Avatar
        icon={<UserAvatar color="var(--marm-color-fg-tertiary)" />}
        size="medium"
        placeholder="User"
        className={styles.trailing_items__user_avatar}
        onPointerEnterCapture={() => {}}
        onPointerLeaveCapture={() => {}}
      /> */}
    </div>
  );
};
